<template>
  <validation-observer v-slot="{ valid }">
    <validation-helper :interceptor="valid" @isValid="$emit('stepReleased', $event)" />
    <v-row class="mx-auto">
      <v-col cols="12">
        <validation-provider v-slot="{ errors }" rules="required">
          <v-text-field id="titulo" v-model="titulo" class="my-0" label="Título" outlined :error-messages="errors" />
        </validation-provider>
      </v-col>
    </v-row>
    <v-row class="mx-auto">
      <v-col cols="12" class="mt-n4">
        <v-alert dense outlined type="info" color="blue" class="mb-0 px-1 py-1">
          - Os arquivos devem seguir as instruções previstas nos itens 1.4 e 1.6.6 do
          <b>manual de dados da ANEEL</b>
          <br />
          - Arquivos permitidos:
          <b>CSV</b>
          <br />
          - Tamanho máximo dos arquivos:
          <b>{{ uploadMaxFilesize }}</b>
          <br />
        </v-alert>
      </v-col>
    </v-row>
    <v-row class="mx-auto">
      <v-col cols="12">
        <upload-files
          id="upload-files-obrigacoes-especiais"
          :extensoes-permitidas="['.csv']"
          :custom-function-upload="require('@/services/ObrigacoesEspeciaisService').default.uploadFile"
          @file:uploaded="handleFileUploaded"
        />
        <tabela-arquivos
          v-if="uploadedFiles.length > 0"
          ref="refMapeamentos"
          :uploaded-files="uploadedFiles"
          @rechargeTable="getAllfiles()"
          @mapeamento:apagar-arquivo="handleMapeamentoArquivoApagado"
        />
      </v-col>
    </v-row>
    <v-row class="mb-n5 mt-n2 mx-auto">
      <v-col cols="12" class="pt-0">
        <parametros-arquivo-csv
          :delimitador.sync="arquivoDelimitador"
          :involucro.sync="arquivoInvolucro"
          :escape.sync="arquivoEscape"
        />
      </v-col>
    </v-row>
    <!-- Exige que tenha no minimo 8 arquivo mapeado para prosseguir com a validação -->
    <validation-provider v-slot="{ errors }" rules="min_value:8">
      <input type="hidden" :value="uploadedFiles.length" :error-messages="errors" />
    </validation-provider>
  </validation-observer>
</template>

<script>
  export default {
    components: {
      ValidationHelper: () => import('@/components/general/ValidationHelper.vue'),
      UploadFiles: () => import('@/components/general/UploadFiles'),
      TabelaArquivos: () => import('@/components/obrigacoesEspeciais/TabelaArquivos'),
      ParametrosArquivoCsv: () => import('@/components/general/GeneralParametrosArquivoCsv.vue')
    },

    emits: ['stepReleased'],

    data: () => ({
      loading: false,
      uploadMaxFilesize: '1024 MB'
    }),

    computed: {
      titulo: {
        get() {
          return this.$store.state.obrigacoesEspeciais.titulo;
        },
        set(value) {
          this.$store.dispatch('setObrigacoesEspeciais', { titulo: value });
        }
      },
      uploadedFiles: {
        get() {
          return this.$store.state.obrigacoesEspeciais.uploadedFiles;
        },
        set(value) {
          this.$store.dispatch('setObrigacoesEspeciais', { uploadedFiles: value });
        }
      },
      arquivoDelimitador: {
        get() {
          return this.$store.state.obrigacoesEspeciais.arquivoDelimitador;
        },
        set(value) {
          this.$store.dispatch('setObrigacoesEspeciais', { arquivoDelimitador: value });
        }
      },
      arquivoInvolucro: {
        get() {
          return this.$store.state.obrigacoesEspeciais.arquivoInvolucro;
        },
        set(value) {
          this.$store.dispatch('setObrigacoesEspeciais', { arquivoInvolucro: value });
        }
      },
      arquivoEscape: {
        get() {
          return this.$store.state.obrigacoesEspeciais.arquivoEscape;
        },
        set(value) {
          this.$store.dispatch('setObrigacoesEspeciais', { arquivoEscape: value });
        }
      }
    },

    methods: {
      handleFileUploaded(event) {
        const files = event.files;
        files.forEach((file) => this.uploadedFiles.push(file));
      },
      handleMapeamentoArquivoApagado(event) {
        this.uploadedFiles = this.uploadedFiles.filter((item) => item.arquivo_id !== event.arquivo_id);
      }
    }
  };
</script>